import logo from './logo.svg';
import './App.css';
import { ConfigProvider } from 'antd';
import Main from './ui/main';
import { BrowserRouter } from 'react-router-dom';
import MainRoutes from './ui/routes';

function App() {
  return (
    <div >
      <ConfigProvider
        theme={{
          token: {
            // Seed Token
            colorPrimary: '#ba1621',
            borderRadius: 2,
            colorText: "#ffffff",
            // fontSize: 18,
            colorBgLayout: '#191d2f',
            // Alias Token
            colorBgContainer: '#191d2f',
          },
        }}
      >
        <div className='app'>
          <BrowserRouter>
             <MainRoutes />
          </BrowserRouter>
        </div>
      </ConfigProvider>
    </div>
  );
}

export default App;
